import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { Form, ErrorMessage, Field, Formik } from "formik"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import {
  addCoupon,
  getAllPromotionsList,
  getCouponDetails,
  updateCoupon,
} from "store/actions/promotionsAction"
import Select from "react-select"
import Switch from "components/Shared/Switch"
import { getAllCustomersList } from "store/actions/customersAction"
import "flatpickr/dist/themes/material_blue.css"
import { showAlert } from "store/reducers/alertReducer"
import { addCouponSchema } from "components/Common/validation"
import Spinners from "components/Shared/Spinners"
import { DatePicker } from "rsuite"
import isBefore from "date-fns/isBefore"
import addCouponUploadTemplate from "assets/file/addCouponUploadTemplate.csv"
import { startOfDay } from "date-fns"
import isPermissionEnabled from "common/isPermissionEnabled"
import {
  getImagePreviewSrc,
  handleFileChange2,
} from "components/Shared/fileHandlers"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"

const initialValues = {
  name: "",
  nameAr: "",
  description: "",
  descriptionAr: "",
  code: "",
  imageType: "UPLOAD",
  imageUrl: "",
  promotion: null,
  isLimitToSpecificCustomer: false,
  allowInfiniteUsage: false,
  maxUsage: 1,
  imageFile: "",
  customers: [],
  startsAt: "",
  expiresAt: "",
  file: "",
  type: "private",
}

const AddCoupon = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = `${mode === "add" ? t("Add") : ""} 
  ${mode === "digitalAdd" ? t("Add Digital") : ""} 
  ${mode === "edit" ? t("Edit Digital") : ""} 
   ${t("Coupon | Namq")}`

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const [formValues, setFormValues] = useState(initialValues)

  const { promotionsList, couponDetails, loading, isLoading } = useSelector(
    state => state.Promotions
  )
  const { customersDropdownList } = useSelector(state => state.Customers)
  const { isImageCompressing } = useSelector(state => state.Common)

  const { userRole, accountType } = useSelector(state => state.Login)
  const [couponType, setCouponType] = useState(null)

  useEffect(() => {
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      14,
      "promotion_2",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      14,
      "promotion_3",
      accountType
    )
    if (mode === "add") {
      if (!isPermissionCreate) {
        navigate("/dashboard")
      }
    } else if (mode === "edit") {
      if (!isPermissionEdit) {
        navigate("/dashboard")
      }
    }
  }, [])

  useEffect(() => {
    const fetchPromotionsList = () => {
      dispatch(getAllPromotionsList())
    }
    fetchPromotionsList()
  }, [])

  useEffect(() => {
    if (mode === "edit") {
      fetchCouponDetails()
    }
  }, [])

  useEffect(() => {
    if (couponDetails && !loading && mode === "edit") {
      const {
        name,
        nameAr,
        description,
        descriptionAr,
        code,
        startsAt,
        expiresAt,
        promotion,
        isLimitToSpecificCustomer,
        allowInfiniteUsage,
        maxUsage,
        customers,
        usageCount,
        type,
        status,
        imageUrlType,
        imageUrl,
      } = couponDetails

      const updatedPromotion = {
        label: promotion?.name,
        value: promotion?._id,
      }

      const updatedCustomers = customers?.map(item => ({
        label: `${item.firstName} ${item.lastName}`,
        value: item._id,
      }))
      setFormValues({
        ...formValues,
        name,
        nameAr,
        code,
        isLimitToSpecificCustomer,
        description: description || "",
        descriptionAr: descriptionAr || "",
        imageType: imageUrlType || "UPLOAD",
        allowInfiniteUsage,
        maxUsage,
        description: description || "",
        descriptionAr: descriptionAr || "",
        imageType: imageUrlType,
        imageUrl: imageUrl || "",
        promotion: updatedPromotion,
        customers: updatedCustomers,
        startsAt: new Date(startsAt),
        expiresAt: new Date(expiresAt),
        type,
      })
      setCouponType(type)
    }
  }, [couponDetails])

  const fetchCouponDetails = () => {
    const payload = { id }
    dispatch(getCouponDetails(payload))
  }

  const [customerOptions, setCustomerOptions] = useState([])

  const fetchCustomersList = keyword => {
    const payload = {
      keyword,
    }
    dispatch(getAllCustomersList(payload))
  }

  useEffect(() => {
    if (customersDropdownList.length > 0) {
      const updatedCustomerOption = customersDropdownList?.map(item => ({
        label: `${item.firstName} ${item.lastName}, ${
          item?.phoneNumber ? item?.phoneNumber : ""
        }`,
        value: item._id,
      }))
      setCustomerOptions(updatedCustomerOption)
      //   console.log(customersDropdownList)
    }
  }, [customersDropdownList])

  const getTimestamp = (date, time) => {
    const year = date.getFullYear()
    const month = date.getMonth()
    const day = date.getDate()
    const hour = time.getHours()
    const minute = time.getMinutes()
    const second = time.getSeconds()
    const millisecond = time.getMilliseconds()

    const timestamp = new Date(
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond
    ).toISOString()

    return timestamp
  }

  const handleOnSubmit = values => {
    const {
      name,
      nameAr,
      description,
      descriptionAr,
      code,
      imageType,
      imageUrl,
      promotion,
      isLimitToSpecificCustomer,
      allowInfiniteUsage,
      maxUsage,
      imageFile,
      customers,
      startsAt,
      expiresAt,
      file,
      type,
    } = values

    const updatedPromotion = promotion.value

    let data = new FormData()
    data.append("name", name)
    data.append("nameAr", nameAr)
    data.append("description", description)
    data.append("descriptionAr", descriptionAr)
    data.append("code", code)
    data.append("imageUrlType", imageType ?? "")
    data.append("imageUrl", imageUrl ?? "")
    data.append("startsAt", startsAt)
    data.append("expiresAt", expiresAt)
    data.append("promotion", updatedPromotion)
    data.append("isLimitToSpecificCustomer", isLimitToSpecificCustomer)
    data.append("allowInfiniteUsage", allowInfiniteUsage)
    data.append("maxUsage", maxUsage)

    if (mode === "add") {
      data.append("type", type)
    } else if (mode === "edit" && couponType === "group") {
      data.append("type", "group")
    } else {
      data.append("type", type)
    }

    if (customers.length === 0) {
      data.append(`customers[]`, [])
    } else {
      customers.forEach((element, index) => {
        data.append(`customers[${index}]`, element.value)
      })
    }
    data.append("image", imageFile)
    if (mode === "add" || mode === "digitalAdd") {
      data.append("file", file)
      dispatch(addCoupon(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate(`/coupons`)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
    if (mode === "edit") {
      data.append("id", id)
      dispatch(updateCoupon(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate(-1)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  const generateCoupon = setFieldValue => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    let code = ""
    const length = 10

    for (let i = 0; i < length; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length))
    }
    setFieldValue("code", code)
  }

  if (mode === "edit" && loading) return <Spinners />

  return (
    <div className="page-content">
      <div className="container-fluid add_coupon_section">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <CardTitle className="mb-2 d-flex align-items-center">
                  <BackButton />
                  {mode === "add" && t("Add")}
                  {mode === "digitalAdd" && t("Add Digital")}
                  {mode === "edit" && t("Edit")} {t("Coupon")}
                </CardTitle>
                <Formik
                  initialValues={formValues}
                  enableReinitialize={true}
                  validationSchema={addCouponSchema(mode)}
                  onSubmit={handleOnSubmit}
                >
                  {({ values, setFieldValue, errors, touched }) => (
                    <Form>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="name">
                              <span className="text-danger">*</span>{" "}
                              {t("Name(English)")}
                            </label>
                            <Field
                              type="text"
                              id="name"
                              name="name"
                              placeholder={t("Name(English)")}
                              className={`form-control ${
                                touched.name && errors.name ? "is-invalid" : ""
                              }`}
                            />
                            <TextError name="name" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="name">
                              <span className="text-danger">*</span>{" "}
                              {t("Name(عربي)")}
                            </label>
                            <Field
                              type="text"
                              id="nameAr"
                              name="nameAr"
                              placeholder={t("Name(عربي)")}
                              className={`form-control ${
                                touched.nameAr && errors.nameAr
                                  ? "is-invalid"
                                  : ""
                              }`}
                              style={{ direction: "rtl" }}
                            />
                            <TextError name="nameAr" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="name">
                              {t("Description(English)")}
                            </label>
                            <Field
                              as="textarea"
                              id="description"
                              name="description"
                              placeholder={t("Description(English)")}
                              className={`form-control`}
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="name">
                              {t("Description(عربي)")}
                            </label>
                            <Field
                              as="textarea"
                              id="descriptionAr"
                              name="descriptionAr"
                              placeholder={t("Description(عربي)")}
                              style={{ direction: "rtl" }}
                              className={`form-control ${
                                touched.descriptionAr && errors.descriptionAr
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="descriptionAr" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="code">
                              <span className="text-danger">*</span>{" "}
                              {t("Coupon Code")}
                            </label>
                            <div className="position-relative">
                              <Field
                                type="text"
                                id="code"
                                name="code"
                                placeholder={t("Coupon Code")}
                                className={`form-control ${
                                  touched.code && errors.code
                                    ? "is-invalid"
                                    : ""
                                }`}
                              />
                              <i
                                className="bx bx-sync bg-primary g_center"
                                onClick={() => generateCoupon(setFieldValue)}
                                id="coupon"
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  transform: "translate(-50%, -50%)",
                                  right: "-20px",
                                  height: "100%",
                                  color: "#fff",
                                  fontSize: 20,
                                  padding: "5px 10px",
                                  borderRadius: "0.25rem",
                                  borderTopLeftRadius: 0,
                                  borderBottomLeftRadius: 0,
                                  cursor: "pointer",
                                }}
                              ></i>
                              <UncontrolledTooltip
                                placement="top"
                                target={`coupon`}
                              >
                                {t("Generate Code")}
                              </UncontrolledTooltip>
                            </div>
                            <TextError name="code" />
                          </div>
                        </div>

                        <div className="col-lg-6 mt-2">
                          <label htmlFor="">
                            {" "}
                            <span className="text-danger">* </span>{" "}
                            {t("Select Discount")}
                          </label>
                          <Select
                            value={values.promotion}
                            onChange={selectedValue => {
                              setFieldValue("promotion", selectedValue)
                            }}
                            options={promotionsList?.map(item => ({
                              label: item.name,
                              value: item._id,
                            }))}
                            placeholder={t("Select Discount")}
                            className={`select2-selection ${
                              touched.promotion && errors.promotion
                                ? "danger_color_border"
                                : ""
                            } `}
                          />
                          <TextError name="promotion" />
                        </div>
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="allowInfiniteUsage">
                                  {t("Allow Infinite Usage")}
                                </label>
                                <Switch
                                  isChecked={values.allowInfiniteUsage}
                                  onClickHandler={() => {
                                    setFieldValue(
                                      "allowInfiniteUsage",
                                      !values.allowInfiniteUsage
                                    )
                                    if (!values.allowInfiniteUsage) {
                                      setFieldValue("maxUsage", 1)
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            {!values.allowInfiniteUsage && (
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="maxUsage">
                                    <span className="text-danger">*</span>{" "}
                                    {t("Max Usage")}
                                  </label>
                                  <Field
                                    type="number"
                                    id="maxUsage"
                                    name="maxUsage"
                                    // readOnly
                                    // disabled
                                    placeholder={t("Max Usage")}
                                    className={`form-control ${
                                      touched.maxUsage && errors.maxUsage
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    pattern="[0-9]*"
                                  />
                                  <TextError name="maxUsage" />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {(mode === "add" ||
                          (mode === "edit" && couponType !== "group")) && (
                          <div className="col-lg-6">
                            <div className="form_field">
                              <label htmlFor="type">
                                {t("Allow Coupon Visibility Publicly")}
                                <i
                                  className="bx bx-info-circle cursor-pointer mx-1 fs-5"
                                  id="type"
                                ></i>
                              </label>{" "}
                              <UncontrolledTooltip
                                placement="top"
                                target={"type"}
                              >
                                {t(
                                  "By default, the coupon visibility is private and can only be used by specific customers. Turn on the toggle to make it available for public use."
                                )}
                              </UncontrolledTooltip>
                              <Switch
                                isChecked={values.type === "public"}
                                onClickHandler={() => {
                                  setFieldValue(
                                    "type",
                                    values.type === "public"
                                      ? "private"
                                      : "public"
                                  )
                                }}
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="isLimitToSpecificCustomer">
                              {t("Limit To Specific Customers")}
                            </label>
                            <Switch
                              isChecked={values.isLimitToSpecificCustomer}
                              onClickHandler={() => {
                                setFieldValue(
                                  "isLimitToSpecificCustomer",
                                  !values.isLimitToSpecificCustomer
                                )
                              }}
                            />
                          </div>
                        </div>

                        {values.isLimitToSpecificCustomer && (
                          <div className="col-lg-6 mt-2">
                            <label htmlFor="">
                              <span className="text-danger">*</span>{" "}
                              {t("Please Type To Search Customer")}
                            </label>
                            <Select
                              value={values.customers}
                              isMulti={true}
                              onChange={selectedValue => {
                                setFieldValue("customers", selectedValue)
                              }}
                              options={customerOptions?.map(item => ({
                                label: item.label,
                                value: item.value,
                              }))}
                              onInputChange={value => fetchCustomersList(value)}
                              placeholder={t("Please Type To Search Customer")}
                              className={`select2-selection ${
                                touched.customers && errors.customers
                                  ? "danger_color_border"
                                  : ""
                              } `}
                            />
                            <TextError name="customers" />
                          </div>
                        )}

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="imageType">
                              {mode === "digitalAdd" && (
                                <span className="text-danger">*</span>
                              )}
                              {t("Image Type")}
                            </label>
                            <Field
                              as="select"
                              id="imageType"
                              name="imageType"
                              className={`form-control ${
                                touched.imageType && errors.imageType
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={e => {
                                const selectedValue = e.target.value
                                setFieldValue("imageType", selectedValue)
                                // Reset the value of imageUrl and imageFile when the image type changes
                                setFieldValue("imageUrl", "")
                                setFieldValue("imageFile", null)
                              }}
                            >
                              <option value="URL">{t("Image Url")}</option>
                              <option value="UPLOAD">
                                {t("Upload Image")}
                              </option>
                            </Field>
                            <TextError name="imageType" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            {/* IMAGE URL */}
                            {values.imageType === "URL" && (
                              <div className="form_field">
                                <label htmlFor="imageUrl">
                                  {mode === "digitalAdd" && (
                                    <span className="text-danger">*</span>
                                  )}
                                  {t("Image URL")}
                                </label>
                                <Field
                                  type="text"
                                  id="imageUrl"
                                  name="imageUrl"
                                  className={`form-control ${
                                    touched.imageUrl && errors.imageUrl
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <TextError name="imageUrl" />
                              </div>
                            )}
                            {/* UPLOAD IMAGE */}
                            {values.imageType === "UPLOAD" && (
                              <div className="form_field position-relative">
                                <label htmlFor="imageFile">
                                  {mode === "digitalAdd" && (
                                    <span className="text-danger">*</span>
                                  )}
                                  {t("Upload Image")}
                                </label>
                                <input
                                  type="file"
                                  id="imageFile"
                                  name="imageFile"
                                  accept="image/jpeg, image/jpg, image/png"
                                  onChange={e => {
                                    handleFileChange2(
                                      e,
                                      "imageFile",
                                      setFieldValue
                                    )
                                  }}
                                  className={`form-control ${
                                    touched.imageFile && errors.imageFile
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <TextError name="imageFile" />
                                {isImageCompressing && (
                                  <Spinner
                                    color="primary"
                                    className="file_upload_btn"
                                  />
                                )}
                              </div>
                            )}
                            {getImagePreviewSrc(mode, values) && (
                              <div className="mt-3">
                                <img
                                  src={getImagePreviewSrc(mode, values)}
                                  alt="Preview"
                                  className="img_preview"
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        {mode === "add" && (
                          <>
                            <div className="col-lg-3">
                              <div className="form_field">
                                <label htmlFor="file">
                                  {t("Invite New Customers")}
                                </label>
                                <input
                                  type="file"
                                  id="file"
                                  name="file"
                                  accept=".csv"
                                  onChange={e => {
                                    setFieldValue(
                                      "file",
                                      e.currentTarget.files[0]
                                    )
                                  }}
                                  className={`form-control `}
                                />
                                <TextError name="file" />
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div style={{ marginTop: 36 }}>
                                <Button
                                  color="primary"
                                  className="ms-3"
                                  type="button"
                                >
                                  <a
                                    href={addCouponUploadTemplate}
                                    download="CSV template.csv"
                                    className="text-white"
                                  >
                                    {t("Download CSV template")}
                                  </a>
                                </Button>
                              </div>
                            </div>
                          </>
                        )}

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="endTime">
                              <span className="text-danger">*</span>{" "}
                              {t("Start Date & Time")}
                            </label>
                            <DatePicker
                              showTime={{ format: "HH:mm" }} // Show time picker
                              format="yyyy-MM-dd HH:mm" // Custom format for displaying date and time
                              onChange={value => {
                                setFieldValue("startsAt", value)
                              }}
                              value={values.startsAt}
                              shouldDisableDate={date =>
                                isBefore(
                                  startOfDay(date),
                                  startOfDay(new Date())
                                )
                              }
                              placement="autoVerticalStart"
                              placeholder=" 2024-07-16 14:30"
                            />

                            <TextError name="startsAt" />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="endTime">
                              <span className="text-danger">*</span>{" "}
                              {t("End Date & Time")}
                            </label>
                            <DatePicker
                              showTime={{ format: "HH:mm" }}
                              format="yyyy-MM-dd HH:mm"
                              onChange={value => {
                                setFieldValue("expiresAt", value)
                              }}
                              value={values.expiresAt}
                              shouldDisableDate={date =>
                                isBefore(
                                  startOfDay(date),
                                  startOfDay(new Date())
                                )
                              }
                              placement="autoVerticalStart"
                              placeholder="2024-07-20 14:30"
                            />

                            <TextError name="expiresAt" />
                          </div>
                        </div>

                        <div className="mt-2"></div>
                        <div className="col-12 d-flex justify-content-end mt-5 mb-5">
                          <Button
                            type="button"
                            className="mx-2"
                            color="secondary"
                            onClick={() => navigate(-1)}
                          >
                            {t("Cancel")}
                          </Button>
                          <Button
                            type="submit"
                            color="success"
                            disabled={isLoading || isImageCompressing}
                            className="w_fit_content"
                          >
                            {mode === "add" ? t("Add") : t("Save")}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AddCoupon
